import FilterInputTypeahead from './FilterInputTypeahead';

export default FilterInputTypeahead;
